import { put, select } from "redux-saga/effects";
import { RewardsAccount } from "redmond";

import { actions } from "../../actions";
import { fetchRewardsAccounts } from "../../../../api/v1/rewards/fetchRewardsAccounts";
import { getRewardsAccounts } from "../../reducer";

export function* fetchRewardsAccountsSaga({ refreshCache }: actions.IFetchRewardsAccounts) {
  try {
    const savedAccounts: RewardsAccount[] = yield select(getRewardsAccounts);
    if (refreshCache || savedAccounts.length < 1) {
      const rewardsAccounts: RewardsAccount[] = yield fetchRewardsAccounts();
      yield put(actions.setRewardsAccounts(rewardsAccounts));
    } else {
      yield put(actions.setRewardsAccounts(savedAccounts));
    }
  } catch (e) {
    yield put(actions.fetchRewardsAccountsCallStateFailed());
  }
}
